import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { useCurrencyContext } from '../hooks/CurrencyContext';
export function StickyCTA() {
  const [visible, setVisible] = useState(false);
  const {
    formatPrice,
    formatPriceShort
  } = useCurrencyContext();
  useEffect(() => {
    const handleScroll = () => {
      setVisible(window.scrollY > window.innerHeight * 0.7);
    };
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <AnimatePresence data-id="element-194">
      {visible && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} transition={{
      duration: 0.3,
      ease: 'easeOut'
    }} className="fixed bottom-0 left-0 right-0 bg-[#3D1F2E]/95 backdrop-blur-sm border-t border-[#C4467E]/30 px-4 py-3 flex items-center justify-between gap-4 max-w-screen-xl mx-auto" style={{
      zIndex: 40
    }} data-id="element-195">
          <div className="hidden sm:block" data-id="element-196">
            <p className="text-white text-sm font-medium" data-id="element-197">
              Anti‑Impulso —{' '}
              <span className="line-through text-[#7A5C6B] text-xs mr-1" data-id="element-198">
                {formatPriceShort(47.99)}
              </span>
              <span className="text-[#C4467E]" data-id="element-199">{formatPrice(7.99)}</span>
            </p>
            <p className="text-[#7A5C6B] text-xs" data-id="element-200">
              🔥 Super Promo · Solo esta semana
            </p>
          </div>
          <div className="sm:hidden" data-id="element-201">
            <p className="text-white text-sm font-bold" data-id="element-202">
              <span className="line-through text-[#7A5C6B] text-xs mr-1" data-id="element-203">
                {formatPriceShort(47.99)}
              </span>{' '}
              {formatPrice(7.99)}
            </p>
          </div>
          <button onClick={() => window.open('https://pay.hotmart.com/N104385148Q', '_blank')} className="flex-shrink-0 bg-[#C4467E] hover:bg-[#A33668] text-white font-medium text-sm px-5 py-2.5 rounded-full flex items-center gap-2 transition-colors shadow-lg" data-id="element-204">
            Comprar ahora
            <ArrowRight className="w-4 h-4" data-id="element-205" />
          </button>
        </motion.div>}
    </AnimatePresence>;
}